<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <BankForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import BankForm from '@/components/settings/test-registers/bank/BankForm'

export default {
  name: 'AddBank',
  components: {
    PageTitle,
    PageRowWrapper,
    BankForm
  }
}
</script>
